import { ChevronRightIcon } from "@heroicons/react/24/solid";

export const TableOfContents = ({ description }: { description: string }) => {
  const getContents = (description: string) => {
    const regex = /<h2[^>]*>(.*?)<\/h2>/gi;
    const matches = description.matchAll(regex);
    const results = Array.from(matches);
    return results;
  };

  return (
    <>
      {getContents(description) && (
        <div>
          <h2
            className={
              "relative text-center font-bold text-xl md:text-2xl mb-5"
            }
          >
            <span
              className={
                "absolute left-1/2 top-1/2 translate-x-[-50%] rounded-[2px] w-[240px] md:w-[336px] h-[4px] bg-[#272727]"
              }
            />
            <span className={"bg-white px-5 relative"}>目次</span>
          </h2>
          <div className={"border border-[#cccccc] p-5"}>
            <ul>
              {getContents(description).map((content, index) => (
                <li
                  className={`font-bold md:text-lg flex ${
                    index + 1 === getContents(description).length
                      ? "mb-0"
                      : "mb-4"
                  }`}
                  key={index}
                >
                  <span className={"pt-[5px] pr-3 md:pt-[6px] md:pr-5"}>
                    <ChevronRightIcon className={"w-5 fill-red-500"} />
                  </span>
                  {content[1]}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};
